import React from 'react';
import Sensations from './Sensations';
import texts from './data.js';

const SensationsCanvas = () => {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        cursor: 'none',
      }}>
        <Sensations
          waveCount={10}
          waveSpeeds={[0.002, 0.003, 0.005, 0.001, 0.008]}
          documentBackgroundColor='beige'
        />
        <Sensations
          waveCount={15}
          waveColors={['rgba(100, 100, 100, 0.4)','rgba(100, 100, 100, 0.2)',]}
          waveSpeeds={[0.002, 0.003, 0.005, 0.001, 0.008]}
          documentBackgroundColor='blue'
          fillColor='white'
          barColor='rgba(255,255,255,0.5)'
          texts={texts[0]}
        />
        <Sensations
          waveCount={1}
          waveColors={['white']}
          waveSpeeds={[0.002]}
          amps={[4]}
          documentBackgroundColor='black'
          fillColor='blue'
          barColor='rgba(255,255,255,0.5)'
          texts={texts[1]}
        />
        <Sensations
          waveCount={8}
          waveColors={[
            'rgba(255,0,0, 0.75)',
            'rgba(255,90,0, 0.75)',
            'rgba(255,206,0, 0.75)',
            'rgba(255,0,0, 0.75)',
            'rgba(255,154,0, 0.75)',
            'rgba(255,0,0, 0.75)',
            'rgba(255,232,8, 0.75)',
            'rgba(255,0,0, 0.75)',
          ]}
          waveSpeeds={[0.014,0.013,0.011,0.012, 0.014,0.013,0.011,0.012]}
          amps={[0.09,0.07,0.08,0.09,0.09,0.07,0.08,0.09]}
          documentBackgroundColor='silver'
          texts={texts[2]}
        />
      </div>
    );
  };
  export default SensationsCanvas;